import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "contactType" })
export class ContactTypePipe implements PipeTransform {
    transform(input: number): string {
        switch (input) {
            case 1:
                return "Driver";
            case 2:
                return "Dispatch";
            case 3:
                return "Owner/Op";
            case 4:
                return "Other";
            default:
                console.warn("ContactType not found: ", input);
                return "N/A";
        }
    }
}
